import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";

class TeamReportsSection7Step1 extends PureComponent {
  get right_content() {
    return (
      <span>
        That's it for now. All the best
        <br />
        in the next round!
      </span>
    );
  }

  render() {
    return (
      <WelcomeLayout title="End of Report" right_content={this.right_content} />
    );
  }
}

export default TeamReportsSection7Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-7/step-5.js